import { apiClient } from '@/core/api/client';
import { ENDPOINTS } from '@/core/api/endpoints';
import { ClienteSchema, ClientesPaginadosSchema, } from '@/data/dto/cliente';
function limpiar(values) {
    const out = {};
    for (const [k, v] of Object.entries(values)) {
        if (v === '' || v === undefined)
            out[k] = null;
        else
            out[k] = v;
    }
    return out;
}
export const clientesApi = {
    async listar(filtros) {
        const res = await apiClient.get(ENDPOINTS.clientes, {
            params: {
                q: filtros.q || undefined,
                activo: filtros.activo,
                pagina: filtros.pagina,
                porPagina: filtros.porPagina,
            },
        });
        return ClientesPaginadosSchema.parse(res.data);
    },
    async ver(id) {
        const res = await apiClient.get(`${ENDPOINTS.clientes}/${id}`);
        return ClienteSchema.parse(res.data);
    },
    async crear(values) {
        const res = await apiClient.post(ENDPOINTS.clientes, limpiar(values));
        return ClienteSchema.parse(res.data);
    },
    async editar(id, values) {
        const res = await apiClient.patch(`${ENDPOINTS.clientes}/${id}`, limpiar(values));
        return ClienteSchema.parse(res.data);
    },
    async desactivar(id) {
        await apiClient.delete(`${ENDPOINTS.clientes}/${id}`);
    },
    async anonimizar(id) {
        const res = await apiClient.post(`${ENDPOINTS.clientes}/${id}/anonimizar`);
        return ClienteSchema.parse(res.data);
    },
};
